import { configureStore } from '@reduxjs/toolkit';
import authReducer    from './authSlice';
import stopsReducer   from './stopsSlice';
import routeReducer   from './routeSlice';
import adminReducer   from './adminSlice';
import uiReducer      from './uiSlice';
import loaderReducer  from './loaderSlice';
import warningReducer from './warningSlice'; 
const store = configureStore({
  reducer: {
    auth:    authReducer,
    stops:   stopsReducer,
    route:   routeReducer,
    admin:   adminReducer,
    ui:      uiReducer,
    loader:  loaderReducer,
    warning: warningReducer,
  },
});

export default store;